import moment from "moment";

export const formatDate = (dateString: string) => {
  return moment.utc(dateString).local().format("MMM D, YYYY, hh:mm:ss.SSS A");
};
